import { Component, h, tag } from "omi";

import { NWCloseButton } from "@/wc/components/atoms/nw-button/closeButton.tsx";
import { useProjectReset } from "@/store/project/mutations/projectReset.ts";
import { triggerToast } from "@/wc/components/base/nw-toast";
import { closeModal, ModalProps, NWButton, NWProBadge, openProModal } from "@/wc/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

export type ProjectResetModalData = {};

type Props = ModalProps<ProjectResetModalData>;

@tag("nw-project-reset-modal")
export class ProjectResetModal extends Component<Props> {
  static css = [tailwind];

  private handleReset = async () => {
    const projectId = Store.project.id.value;

    if (projectId == null) {
      return;
    }

    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackProjectResetTriggered(projectId, true);
    });

    const res = await Store.project.resetProject();
    if (res) {
      closeModal();
      triggerToast({ message: "Project successfully reset", position: "top" });
    }
  };

  private handleProModal = () => {
    const projectId = Store.project.id.value;
    if (projectId) {
      import("@/services/analyticsService").then(({ useAnalyticsService }) => {
        useAnalyticsService().trackProjectResetTriggered(projectId, false);
      });
    }

    closeModal();
    setTimeout(() => {
      openProModal("project_reset");
    }, 350);
  };

  renderCta() {
    if (Store.user.isPro()) {
      return (
        <NWButton
          type="danger"
          className="w-full"
          size="full"
          onClick={this.handleReset}
          loading={useProjectReset().signal.isLoading.value}
          loadingColor="white"
        >
          Restart project
        </NWButton>
      );
    }

    return (
      <NWButton
        type="primary"
        className="w-full"
        size="full"
        onClick={this.handleProModal}
        loading={false}
        loadingColor="white"
        loadingText="Unlock"
      >
        Unlock with Pro
      </NWButton>
    );
  }

  render({ close }: Props) {
    return (
      <div className="bg-white rounded-lg shadow-xl max-w-md p-6" role="dialog" aria-modal="true">
        <div className="content flex flex-col">
          <div className="header flex items-center justify-between">
            <NWProBadge location="project-reset" />

            <NWCloseButton size="md" onClick={close} />
          </div>

          <div className="mt-1 mb-6">
            <div className="space-y-1">
              <h3 className="font-semibold text-lg text-primary">Restart project</h3>
              <p className="text-tertiary text-sm ">
                Are you sure you want to restart the project? All task answers, highlights, notes, and existing
                documentation will be cleared.
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col-reverse sm:flex-row space-y-2 gap-2 sm:space-y-0 sm:space-x-2">
            {this.renderCta()}
          </div>
        </div>
      </div>
    );
  }
}
